import React, { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api } from "@/lib/api";
import { formatDeShortDateTime } from "@/lib/date";

const ACTION = { draft_created: "Vorschlag erstellt", approved: "Vom Coach freigegeben", rejected: "Vom Coach abgelehnt", moved: "Verschoben",
  sent: "An Teilnehmer gesendet", confirmed: "Vom Teilnehmer bestätigt", change_requested: "Änderungswunsch", conflict: "Konflikt",
  expired: "Termin verstrichen", sessions_set: "Terminanzahl geändert", reminder: "Erinnerung an Teilnehmer", handover_ready: "Bereit zur Übergabe", cancelled_timely: "Rechtzeitig abgesagt", cancelled_late: "Kurzfristig abgesagt", outcome_no_show: "Nicht erschienen", outcome_attended: "Erschienen", outcome_late: "Verspätet", outcome_technical: "Technisch nicht durchführbar", outcome_coach_cancelled: "Durch Coach abgesagt", credit_credited: "Angerechnet", credit_not_credited: "Nicht angerechnet", rescheduled_vacation: "Wegen Abwesenheit verschoben", sync_error: "Sync-Fehler" };

export default function PlannerHistoryCard({ clientId }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/planner/history/${clientId}`).then((r) => setRows(r.data)).catch(() => setRows(null)); }, [clientId]);
  if (!rows?.length) return null;
  return (
    <details className="border border-slate-200 bg-white px-5 py-4 mt-6" data-testid="planner-history-card">
      <summary className="text-[10px] font-bold uppercase tracking-overline text-slate-500 cursor-pointer flex items-center gap-2"><History size={13} /> Terminplanung – Historie ({rows.length})</summary>
      <ul className="mt-3 space-y-1 max-h-64 overflow-y-auto">
        {rows.map((r) => (
          <li key={r.log_id} className="text-xs text-slate-700" data-testid={`planner-history-${r.log_id}`}>
            <span className="font-mono text-slate-500">{formatDeShortDateTime(r.at)}</span> · <b>{ACTION[r.action] || r.action}</b>
            {r.date && ` · ${r.date.split("-").reverse().join(".")} ${r.time_from || ""}`} · {r.by}{r.detail && ` · ${r.detail}`}
          </li>
        ))}
      </ul>
    </details>
  );
}
